module.exports = __webpack_public_path__ + "static/img/6.9f194d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/6.png
// module id = jhWZ
// module chunks = 0